import { RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { CategorySummaryDTO } from 'services/api/models/CategoryDTO';
import { CategoryIconBox } from './CategoryIcon';
import { openCategory } from './navigation';

/**
 * A list of categories as rows: icon, name and one line naming what is inside,
 * so that someone looking for "mycose" sees it without opening anything.
 */
export default function CategoryRows({
  categories,
  openedFrom,
  getSubline,
  testIdPrefix = 'category',
}: {
  categories: CategorySummaryDTO[];
  openedFrom: string;
  getSubline?: (category: CategorySummaryDTO) => string | undefined;
  testIdPrefix?: string;
}) {
  const navigate = useNavigate();

  const subline = (category: CategorySummaryDTO) =>
    getSubline?.(category) ??
    (category.children_names.length > 0 ? category.children_names.join(', ') : category.description);

  return (
    <div className="flex flex-col divide-y overflow-hidden rounded-lg bg-card shadow-xs">
      {categories.map((category, index) => {
        const open = () => openCategory(navigate, category.slug, openedFrom);
        return (
          <div
            key={category.id}
            className="flex cursor-pointer items-center gap-3 px-3.5 py-3"
            data-testid={`${testIdPrefix}-${index}`}
            onClick={open}
            onKeyDown={e => {
              if (e.key === 'Enter') open();
            }}
            role="button"
            tabIndex={0}
          >
            <CategoryIconBox category={category} />
            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
              <h4 className="text-base">{category.name}</h4>
              {subline(category) && <span className="truncate text-sm text-muted-foreground">{subline(category)}</span>}
            </span>
            <RightOutlined className="text-xs text-muted-foreground" />
          </div>
        );
      })}
    </div>
  );
}
